import { render, staticRenderFns } from "./UpdateTableSize.vue?vue&type=template&id=2a4bb6ce"
import script from "./UpdateTableSize.vue?vue&type=script&lang=js"
export * from "./UpdateTableSize.vue?vue&type=script&lang=js"
import style0 from "./UpdateTableSize.vue?vue&type=style&index=0&id=2a4bb6ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports